"use strict";

exports.__esModule = true;
exports["default"] = Bullet;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Bullet(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "-1 3 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7 9c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0-1.6C5 7.4 3.4 9 3.4 11S5 14.6 7 14.6s3.6-1.6 3.6-3.6S9 7.4 7 7.4z"
  }));
}